import React from "react";
import { Theme } from "@pga/pga-component-library";
import styled from "styled-components";
import { jobStatData } from "./utils";

const JobStatsContainer = styled.div`
  margin-top: 20px;
`;

const JobStatBlockContainer = styled.div`
  color: ${Theme.colors.primary};
  font-family: ${Theme.fonts.Montserrat};
  font-size: 16px;
  font-weight: bold;
  line-height: 9px;
  background-color: ${Theme.colors.white};

  h4 {
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
    margin-bottom: 20px;
  }

  p {
    margin: 5px;
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
  }
`;

const BodyItemIcon = styled.i.attrs((props) => ({
  className: `pga-icon pga-${props.name}-icon`,
}))`
  height: 16px;
  width: 16px;
  margin-right: 5px;
  color: ${Theme.colors.blueGray};
  font-size: 10px;
  vertical-align: 15%;
`;

export const JobStatBlock = ({ title, data, icon }) => (
  <JobStatBlockContainer>
    <h4>
      <BodyItemIcon name={icon} /> {title}: {data}
    </h4>
  </JobStatBlockContainer>
);

export default ({ job = {} }) => (
  <JobStatsContainer>
    {jobStatData(job).map(({ title, data, icon }) =>
      data ? (
        <JobStatBlock key={title} title={title} data={data} icon={icon} />
      ) : null,
    )}
  </JobStatsContainer>
);
